/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Pwrdby.QuickMD.Admins.Api
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  EncounterUrlStaffApiOutContract,
  ErrorApiOutContract,
  ErrorDescription,
  PrescriptionStaffApiOutContract
} from '../pwrdbyQuickMDAdminsApi.schemas';

import { fetcher } from '@quickmd-llc/frontend-utils';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Retrieves all prescriptions for a specific patient.
 */
export const getPatientsPatientIdPrescriptions = (
    patientId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<PrescriptionStaffApiOutContract[]>(
      {url: `https://admins-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/prescriptions`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPatientsPatientIdPrescriptionsInfiniteQueryKey = (patientId?: string,) => {
    return [
    'infinite', `https://admins-api.api.quick.md/api/v1/patients/${patientId}/prescriptions`
    ] as const;
    }

export const getGetPatientsPatientIdPrescriptionsQueryKey = (patientId?: string,) => {
    return [
    `https://admins-api.api.quick.md/api/v1/patients/${patientId}/prescriptions`
    ] as const;
    }

    
export const getGetPatientsPatientIdPrescriptionsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdPrescriptionsInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>> = ({ signal }) => getPatientsPatientIdPrescriptions(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdPrescriptionsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>>
export type GetPatientsPatientIdPrescriptionsInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdPrescriptionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPrescriptionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPrescriptionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves all prescriptions for a specific patient.
 */

export function useGetPatientsPatientIdPrescriptionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdPrescriptionsInfiniteQueryOptions(patientId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves all prescriptions for a specific patient.
 */
export const prefetchGetPatientsPatientIdPrescriptionsInfiniteQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdPrescriptionsInfiniteQueryOptions(patientId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdPrescriptionsQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdPrescriptionsQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>> = ({ signal }) => getPatientsPatientIdPrescriptions(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdPrescriptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>>
export type GetPatientsPatientIdPrescriptionsQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdPrescriptions<TData = Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPrescriptions<TData = Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPrescriptions<TData = Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves all prescriptions for a specific patient.
 */

export function useGetPatientsPatientIdPrescriptions<TData = Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdPrescriptionsQueryOptions(patientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves all prescriptions for a specific patient.
 */
export const prefetchGetPatientsPatientIdPrescriptionsQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdPrescriptionsQueryOptions(patientId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdPrescriptionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdPrescriptionsQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>> = ({ signal }) => getPatientsPatientIdPrescriptions(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdPrescriptionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>>
export type GetPatientsPatientIdPrescriptionsSuspenseQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdPrescriptionsSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPrescriptionsSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPrescriptionsSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves all prescriptions for a specific patient.
 */

export function useGetPatientsPatientIdPrescriptionsSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdPrescriptionsSuspenseQueryOptions(patientId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPatientsPatientIdPrescriptionsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdPrescriptionsInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>> = ({ signal }) => getPatientsPatientIdPrescriptions(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdPrescriptionsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>>
export type GetPatientsPatientIdPrescriptionsSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdPrescriptionsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPrescriptionsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPrescriptionsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves all prescriptions for a specific patient.
 */

export function useGetPatientsPatientIdPrescriptionsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdPrescriptionsSuspenseInfiniteQueryOptions(patientId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Retrieves all prescriptions for a specific visit.
 */
export const getVisitsVisitIdPrescriptions = (
    visitId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<PrescriptionStaffApiOutContract[]>(
      {url: `https://admins-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}/prescriptions`, method: 'GET', signal
    },
      options);
    }
  



export const getGetVisitsVisitIdPrescriptionsInfiniteQueryKey = (visitId?: string,) => {
    return [
    'infinite', `https://admins-api.api.quick.md/api/v1/visits/${visitId}/prescriptions`
    ] as const;
    }

export const getGetVisitsVisitIdPrescriptionsQueryKey = (visitId?: string,) => {
    return [
    `https://admins-api.api.quick.md/api/v1/visits/${visitId}/prescriptions`
    ] as const;
    }

    
export const getGetVisitsVisitIdPrescriptionsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdPrescriptionsInfiniteQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>> = ({ signal }) => getVisitsVisitIdPrescriptions(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(visitId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdPrescriptionsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>>
export type GetVisitsVisitIdPrescriptionsInfiniteQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdPrescriptionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdPrescriptionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdPrescriptionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves all prescriptions for a specific visit.
 */

export function useGetVisitsVisitIdPrescriptionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdPrescriptionsInfiniteQueryOptions(visitId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves all prescriptions for a specific visit.
 */
export const prefetchGetVisitsVisitIdPrescriptionsInfiniteQuery = async <TData = Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetVisitsVisitIdPrescriptionsInfiniteQueryOptions(visitId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetVisitsVisitIdPrescriptionsQueryOptions = <TData = Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdPrescriptionsQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>> = ({ signal }) => getVisitsVisitIdPrescriptions(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(visitId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdPrescriptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>>
export type GetVisitsVisitIdPrescriptionsQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdPrescriptions<TData = Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdPrescriptions<TData = Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdPrescriptions<TData = Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves all prescriptions for a specific visit.
 */

export function useGetVisitsVisitIdPrescriptions<TData = Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdPrescriptionsQueryOptions(visitId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves all prescriptions for a specific visit.
 */
export const prefetchGetVisitsVisitIdPrescriptionsQuery = async <TData = Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetVisitsVisitIdPrescriptionsQueryOptions(visitId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetVisitsVisitIdPrescriptionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdPrescriptionsQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>> = ({ signal }) => getVisitsVisitIdPrescriptions(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdPrescriptionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>>
export type GetVisitsVisitIdPrescriptionsSuspenseQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdPrescriptionsSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdPrescriptionsSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdPrescriptionsSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves all prescriptions for a specific visit.
 */

export function useGetVisitsVisitIdPrescriptionsSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdPrescriptionsSuspenseQueryOptions(visitId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetVisitsVisitIdPrescriptionsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdPrescriptionsInfiniteQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>> = ({ signal }) => getVisitsVisitIdPrescriptions(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdPrescriptionsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>>
export type GetVisitsVisitIdPrescriptionsSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdPrescriptionsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdPrescriptionsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdPrescriptionsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves all prescriptions for a specific visit.
 */

export function useGetVisitsVisitIdPrescriptionsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdPrescriptionsSuspenseInfiniteQueryOptions(visitId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * # Possible Errors
| HTTP status | ErrorCode                    | Description                                                       |
|-------------|------------------------------|-------------------------------------------------------------------|
| 403         | Permission                   | The admin lacks the prescription.encounter.create permission.     |
| 403         | Forbidden                    | Prescription is not allowed for this visit.                       |
| 404         | VisitNotFound                | The visit could not be found.                                     |
| 502         | ScriptSureCommunicationError | ScriptSure could not resolve the encounter.                       |
 * @summary Resolves a ScriptSure encounter for the visit as the acting support user and returns the patient chart URL. Reuses the visit's most recent encounter if one exists.
 */
export const getVisitsVisitIdEncounterUrl = (
    visitId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<EncounterUrlStaffApiOutContract>(
      {url: `https://admins-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}/encounterUrl`, method: 'GET', signal
    },
      options);
    }
  



export const getGetVisitsVisitIdEncounterUrlInfiniteQueryKey = (visitId?: string,) => {
    return [
    'infinite', `https://admins-api.api.quick.md/api/v1/visits/${visitId}/encounterUrl`
    ] as const;
    }

export const getGetVisitsVisitIdEncounterUrlQueryKey = (visitId?: string,) => {
    return [
    `https://admins-api.api.quick.md/api/v1/visits/${visitId}/encounterUrl`
    ] as const;
    }

    
export const getGetVisitsVisitIdEncounterUrlInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>>, TError = void | ErrorDescription | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdEncounterUrlInfiniteQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>> = ({ signal }) => getVisitsVisitIdEncounterUrl(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(visitId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdEncounterUrlInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>>
export type GetVisitsVisitIdEncounterUrlInfiniteQueryError = void | ErrorDescription | ErrorApiOutContract


export function useGetVisitsVisitIdEncounterUrlInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdEncounterUrlInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdEncounterUrlInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Resolves a ScriptSure encounter for the visit as the acting support user and returns the patient chart URL. Reuses the visit's most recent encounter if one exists.
 */

export function useGetVisitsVisitIdEncounterUrlInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdEncounterUrlInfiniteQueryOptions(visitId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Resolves a ScriptSure encounter for the visit as the acting support user and returns the patient chart URL. Reuses the visit's most recent encounter if one exists.
 */
export const prefetchGetVisitsVisitIdEncounterUrlInfiniteQuery = async <TData = Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 queryClient: QueryClient, visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetVisitsVisitIdEncounterUrlInfiniteQueryOptions(visitId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetVisitsVisitIdEncounterUrlQueryOptions = <TData = Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError = void | ErrorDescription | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdEncounterUrlQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>> = ({ signal }) => getVisitsVisitIdEncounterUrl(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(visitId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdEncounterUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>>
export type GetVisitsVisitIdEncounterUrlQueryError = void | ErrorDescription | ErrorApiOutContract


export function useGetVisitsVisitIdEncounterUrl<TData = Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdEncounterUrl<TData = Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdEncounterUrl<TData = Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Resolves a ScriptSure encounter for the visit as the acting support user and returns the patient chart URL. Reuses the visit's most recent encounter if one exists.
 */

export function useGetVisitsVisitIdEncounterUrl<TData = Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdEncounterUrlQueryOptions(visitId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Resolves a ScriptSure encounter for the visit as the acting support user and returns the patient chart URL. Reuses the visit's most recent encounter if one exists.
 */
export const prefetchGetVisitsVisitIdEncounterUrlQuery = async <TData = Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 queryClient: QueryClient, visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetVisitsVisitIdEncounterUrlQueryOptions(visitId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetVisitsVisitIdEncounterUrlSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError = void | ErrorDescription | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdEncounterUrlQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>> = ({ signal }) => getVisitsVisitIdEncounterUrl(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdEncounterUrlSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>>
export type GetVisitsVisitIdEncounterUrlSuspenseQueryError = void | ErrorDescription | ErrorApiOutContract


export function useGetVisitsVisitIdEncounterUrlSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdEncounterUrlSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdEncounterUrlSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Resolves a ScriptSure encounter for the visit as the acting support user and returns the patient chart URL. Reuses the visit's most recent encounter if one exists.
 */

export function useGetVisitsVisitIdEncounterUrlSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdEncounterUrlSuspenseQueryOptions(visitId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetVisitsVisitIdEncounterUrlSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>>, TError = void | ErrorDescription | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdEncounterUrlInfiniteQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>> = ({ signal }) => getVisitsVisitIdEncounterUrl(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdEncounterUrlSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>>
export type GetVisitsVisitIdEncounterUrlSuspenseInfiniteQueryError = void | ErrorDescription | ErrorApiOutContract


export function useGetVisitsVisitIdEncounterUrlSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdEncounterUrlSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdEncounterUrlSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Resolves a ScriptSure encounter for the visit as the acting support user and returns the patient chart URL. Reuses the visit's most recent encounter if one exists.
 */

export function useGetVisitsVisitIdEncounterUrlSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdEncounterUrlSuspenseInfiniteQueryOptions(visitId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




